import { useSelector } from 'react-redux';

const mapState = (userId: number) => {
  return (state: Store.State) => state.contacts[userId];
};

export const useSelectContact = (userId: number) => {
  return useSelector(mapState(userId));
};